<template>
  <div class="limiter">
    <div class="container-login">
      <v-container fluid>
        <v-row align="center" justify="center">
          <v-col cols="12" sm="12" md="8" lg="8">
            <v-card class="login" flat style="border-radius: 10px" color="black">
              <span class="login-title">
                <img :src="empresa.logoUrl" width="100%" style="max-width: 80px">
              </span>
              <v-card-text style="padding: 0px">
                <v-container fluid grid-list-md>
                  <v-layout row wrap justify-center v-for="evento in eventos" :key="evento.id">
                    <v-col cols="12" sm="12" md="8" lg="8">
                      <v-card dark style="background: #666">
                        <div class="d-flex flex-no-wrap justify-space-between">
                          <div>
                            <v-card-title class="text-h6 ma-0 no-break" style="padding-bottom: 0px">{{ evento.nome.split('|')[0].split(' ')[0] }}</v-card-title>
                            <v-card-title class="text-h6 ma-0 no-break" style="padding-top: 0px">{{ evento.nome.split('|')[0].split(' ')[1] }}</v-card-title>
                            <v-card-subtitle></v-card-subtitle>
                            <v-card-actions>
                              <router-link :to="'/baboonrn?e=' + evento.id" style="text-decoration: none">
                                <v-btn class="ml-2 mb-2" height="40px" outlined right width="140px">Compre aqui</v-btn>
                              </router-link>
                            </v-card-actions>
                          </div>
                          <v-avatar class="ma-3" size="100" tile>
                            <v-img contain :src="evento.urlCapa"></v-img>
                          </v-avatar>
                        </div>
                      </v-card>
                    </v-col>
                  </v-layout>
                  <v-layout row wrap justify-center>
                    <v-col cols="12" sm="12" md="8" lg="8">
                      <v-card dark style="background: #333">
                        <div class="d-flex flex-no-wrap justify-space-between">
                          <div>
                            <v-card-title class="text-h6 mx-auto no-break">Fale conosco</v-card-title>
                            <v-card-subtitle></v-card-subtitle>
                            <v-card-actions>
                              <v-btn class="ml-2 mb-2" height="40px" outlined right :href="'https://wa.me/5588981321828?text=Olá!%20Gostaria%20de%20ter%20informações%20sobre%20os%20produtos%20Baboon.'" target="_blank">
                                Comprar produtos
                              </v-btn>
                            </v-card-actions>
                          </div>
                          <v-avatar class="ma-3" size="100" tile>
                            <v-icon size="60">mdi-whatsapp</v-icon>
                          </v-avatar>
                        </div>
                      </v-card>
                    </v-col>
                    <v-col cols="12" sm="12" md="8" lg="8">
                      <v-card dark style="background: #333">
                        <div class="d-flex flex-no-wrap justify-space-between">
                          <div>
                            <v-card-title class="text-h6 mx-auto no-break">Fale conosco</v-card-title>
                            <v-card-subtitle></v-card-subtitle>
                            <v-card-actions>
                              <v-btn class="ml-2 mb-2" height="40px" outlined right width="140px" :href="'https://wa.me/5588981079639?text=Olá,%20pode%20me%20ajudar%20com%20os%20eventos%20da%20empresa%20' + empresa.nome + '?'" target="_blank">
                                Eventos
                              </v-btn>
                            </v-card-actions>
                          </div>
                          <v-avatar class="ma-3" size="100" tile>
                            <v-icon size="60">mdi-whatsapp</v-icon>
                          </v-avatar>
                        </div>
                      </v-card>
                    </v-col>
                  </v-layout>
                </v-container>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
        <br>
        <div class="login-title">
          <a href="https://www.intelitetecnologia.com.br/" target="_blank">
            <img src="../../assets/LogoBrancoHorizontal.png" width="150px">
          </a>
        </div>
      </v-container>
    </div>
    <loading :active.sync="isLoading" :can-cancel="true" color="#00695C" :is-full-page="fullPage"></loading>
  </div>
</template>

<script>
  import { baseApiUrl } from '@/global'
  import Loading from 'vue-loading-overlay';
  import 'vue-loading-overlay/dist/vue-loading.css';
  import { mapState } from 'vuex'
  import axios from 'axios'
  export default {
    components: {
      Loading
    },

    name: 'Auth',
    computed: mapState({
      usuarioLogado: state => state.isMenuVisible,
    }),

    data: function () {
      return {
        isLoading: false,
        fullPage: true,
        imagemLiberdade: require('../../assets/logoLiberdade.png'),
        imagemKids: require('../../assets/kids.jpeg'),
        imagemLiberty: require('../../assets/conference2021.png'),
        imagemValentes: require('../../assets/valentes.png'),
        empresa: [],
        eventos: [],
      }
    },

    mounted: function () {
      this.carregaDados()
      this.$validator.localize('pt', this.dictionary)
    },

    methods: {
      async carregaDados() {
        this.isLoading = true

        await axios.post(baseApiUrl + 'eventos/eventosFuturos', {"empresaId":"65b7edde3e911469eb28dc04"})
        .then(async response => {
          this.empresa = response.data.empresa
          this.eventos = response.data.eventos

          this.isLoading = false
        })
      },
    }
  }
</script>

<style scoped>
  /* LOGIN */

  .limiter {
    width: 100%;
    margin: 0 auto;
  }

  .container-login {
    width: 100%;
    min-height: 100vh;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    padding: 15px;
    background: linear-gradient(to right, #333, #333);
    background-repeat: no-repeat;
    position: relative;
    z-index: 1;
  }

  .texto {
    font-weight: bold;
    color: #00253E;
    font-size: 17px;
  }

  .login {
    min-width: 80%;
    border-radius: 15px;
    background-color: #fff;
    opacity: 0.9;
    padding-top: 15px;
    padding-bottom: 15px;
  }

  .login-title {
    display: block;
    margin-left: auto;
    margin-right: auto;
    text-align: center
  }
</style>